import { useEffect } from "react";
import { useNavigate } from "react-router";
import { injectIntl } from "react-intl";
import { Box, Button, Grid2 as Grid, Stack, Typography } from "@mui/material";
import { ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon } from "@mui/icons-material";
import {
  PATH_PRIVACY_POLICY,
  PATH_COOKIE_POLICY,
  PATH_DICHIARAZIONE_ACCESSIBILITA,
  PATH_COLORI_TRIAGE,
  PATH_FAQ,
  PATH_CONTATTI,
  PATH_HOME,
} from "../../path";
import {
  BACK,
  FOOTER_PRIVACY_POLICY,
  FOOTER_COOKIE_POLICY,
  FOOTER_ACCESSIBILITA,
  FOOTER_COLORI_TRIAGE,
  FOOTER_FAQ,
  FOOTER_CONTATTI,
  INFO_LABEL,
} from "../../modules/language";
import { CambioLingua, Icona } from "../shared";
import { getMessageString } from "../../utility";

export const Info = injectIntl(({ intl }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1199) navigate(PATH_HOME);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Box className="infoPage">
      <Stack className="infoPageHeader">
        <Button startIcon={<ArrowBackIosNewOutlinedIcon />} onClick={() => navigate(-1)}>
          {getMessageString(intl, BACK)}
        </Button>
        <CambioLingua />
      </Stack>
      <Stack className="pageTitle">
        <Icona tipologia="faq" />
        <Typography variant="h2">{getMessageString(intl, INFO_LABEL)}</Typography>
      </Stack>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Button startIcon={<Icona tipologia="privacy" />} onClick={() => navigate(PATH_PRIVACY_POLICY)}>
            {getMessageString(intl, FOOTER_PRIVACY_POLICY)}
          </Button>
        </Grid>
        <Grid size={12}>
          <Button startIcon={<Icona tipologia="cookies" />} onClick={() => navigate(PATH_COOKIE_POLICY)}>
            {getMessageString(intl, FOOTER_COOKIE_POLICY)}
          </Button>
        </Grid>
        <Grid size={12}>
          <Button startIcon={<Icona tipologia="accessibilita" />} onClick={() => window.open(PATH_DICHIARAZIONE_ACCESSIBILITA, "_blank")}>
            {getMessageString(intl, FOOTER_ACCESSIBILITA)}
          </Button>
        </Grid>
        <Grid size={12}>
          <Button startIcon={<Icona tipologia="lista" />} onClick={() => navigate(PATH_COLORI_TRIAGE)}>
            {getMessageString(intl, FOOTER_COLORI_TRIAGE)}
          </Button>
        </Grid>
        <Grid size={12}>
          <Button startIcon={<Icona tipologia="faq" />} onClick={() => navigate(PATH_FAQ)}>
            {getMessageString(intl, FOOTER_FAQ)}
          </Button>
        </Grid>
        <Grid size={12}>
          <Button startIcon={<Icona tipologia="email" />} onClick={() => navigate(PATH_CONTATTI)}>
            {getMessageString(intl, FOOTER_CONTATTI)}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
});
